import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function HealthRecordForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [recordType, setRecordType] = useState("doctor");
  const [title, setTitle] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title) return;

    onAdd({
      date: new Date(date).toISOString(),
      recordType: recordType,
      title: title,
      notes: notes || "",
      type: "healthRecord"
    });

    setDate(toDatetimeLocal());
    setTitle("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Record Type</label>
          <select
            className="form-select"
            value={recordType}
            onChange={(e) => setRecordType(e.target.value)}
          >
            <option value="doctor">👨‍⚕️ Doctor Visit</option>
            <option value="vaccination">💉 Vaccination</option>
            <option value="test">🧪 Test/Exam</option>
            <option value="other">📋 Other</option>
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label">Title/Description</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 8-month checkup"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Details, results, etc."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button type="submit" className="btn btn-primary w-100">
            Add Record
          </button>
        </div>
      </div>
    </form>
  );
}
